export enum FetchErrorName {
  NetworkError = 'NetworkError',
  ParsingError = 'ParsingError',
  UnauthorizedError = 'UnauthorizedError',
  ForbiddenError = 'ForbiddenError',
}

export enum ForbiddenErrors {
  TABLE_BLOCKED_FOR_COUNTRY = 'TABLE_BLOCKED_FOR_COUNTRY',
  RESTRICT_USER = 'RESTRICT_USER',
}

export const ERROR_TABLE_BLOCKED_FOR_COUNTRY_CODE = 1052;
